import "./ModalLoader.scss";

const ModalLoader = () => {
  return (
    <div id="modalLoader" className="loading-dots-wrapper">
      <div className="mm-dots-loading-lg"></div>
    </div>
  );
};
export default ModalLoader;
